import { createI18n } from "vue-i18n";
import { getTranslations, QFood } from "@q-food/q-food";

const i18n = createI18n({
  locale: "nl",
  messages: {}
});

QFood.BASE_URL = `${window.location.protocol}//${window.location.host}`;
getTranslations("nl").then((translations) => {
  i18n.global.setLocaleMessage("nl", translations);
});

function translate(key: string) {
  return i18n.global.t(key);
}

export { i18n, translate };
export default i18n;
